import BaseAPI from "@/api/BaseAPI";

export class ExpertAPI extends BaseAPI {
    constructor() {
        super('/experts');
    }

    getApplicationArchive(orgId) {
        return this.http.get(`/archive?orgId=${orgId}`)
    }

    setComment(orgId, comment) {
        return this.http.post(`/set_comment`, {data: {orgId: orgId, comment: comment}})
    }

    getProtocols() {
        return this.http.get(`/protocols`);
    }

    setAnswer(protocolId, questionId, answer, comment) {
        const data = {
            questionId: questionId,
            protocolId: protocolId,
            answerNumber: answer,
            comment: comment
        };
        return this.http.post(`/set_answer`, {data: data});
    }
}

export default new ExpertAPI();